<template>
  <v-app>
    <v-app-bar
      app
      color="rgb(14, 40, 184)"
      dark
      extended
      extension-height="16"
    >
      <div class="d-flex align-center">
        <a :href='qLink'>
          <v-img
            class="q-app-logo"
            contain
            src="/ext_files/prepaid/q/media/myqlogo.svg"
            transition="scale-transition"
          />
        </a>
      </div>

      <!-- <v-spacer></v-spacer> -->
    </v-app-bar>

    <v-main class="body-section">
      <FriendDashboard v-if="showDashboard"/>
      <Landing @verified='showDashboard = true' v-if="!showDashboard"/>
    </v-main>
  </v-app>
</template>

<script>
import FriendDashboard from './components/FriendDashboard.vue'
import Landing from './components/Landing.vue'
import { mapActions } from 'vuex'

export default {
  name: 'App',

  components: {
    FriendDashboard,
    Landing
  },

  data: () => ({
    showDashboard: false,
    qLink: ''
  }),
  methods: {
    ...mapActions([
      'loadMessages',
    ]),
  },
  mounted () {
    let locale = 'el_GR'
    if (document.getElementsByTagName('body')[0].dataset.locale !== undefined) {
      locale = document.getElementsByTagName('body')[0].dataset.locale
      this.$store.commit('setFullLocale', locale)
      if (locale === 'en_US') {
        this.qLink = '/en/'
        this.$store.commit('setLocale', 'en')
      }else{
        this.qLink = '/gr/'
        this.$store.commit('setLocale', 'gr')
      }
    }
    const self = this
    if (sessionStorage.messages && (JSON.parse(sessionStorage.messages))[locale]) {
      self.$store.commit('setMessages', JSON.parse(sessionStorage.messages)[locale])
    } else {
      self.loadMessages(locale)
    }
  },
};
</script>

<style scoped>
@import './assets/styles/style.css';
</style>